import Link from "next/link";
import getConfig from "next/config";
import classNames from "classnames";

import ImageWithFallback from "@components/ImageWithFallback";
import { resizeImage } from "@lib/helpers";
import AppleFeaturedCategoryProductCard from "@components/ShopInShop/Apple/AppleFeaturedCategoryProductCard";

const {
  publicRuntimeConfig: {
    settings: { websiteStatics },
  },
} = getConfig();

const AppleFeaturedCategoryCard = ({ category, onProductClick }) => (
  <ul className="grid grid-cols-2 md:grid-cols-[35%_1fr_1fr_1fr] gap-[16px] w-full">
    <div
      className={classNames(
        "col-start-1 row-start-1 col-span-full md:col-span-1 flex flex-col items-center justify-center gap-[16px] bg-[#F5F5F7] rounded-[10px] px-[10px] py-[16px] md:min-w-[38%] lg:min-w-[30%]"
      )}
    >
      <ImageWithFallback
        src={category.image ? resizeImage(category.image, "300x300") : null}
        fallback={`${websiteStatics}/images/applePlaceholder.svg`}
        alt={category.name}
        className="w-[180px] aspect-square md:w-[300px]"
      />

      <Link href={category.url}>
        <a
          title={`Vezi toata gama ${category.name}`}
          className="text-[#2A64C5] text-[18px] text-center py-[16px] px-[32px] border border-[#2A64C5] rounded-full md:text-[20px] hover:opacity-80 transition-opacity transition-duration-150"
        >
          Vezi toata gama {category.name}
        </a>
      </Link>
    </div>

    {category.featured_products?.length > 0 &&
      category.featured_products.map((product, index) => (
        <li
          className={classNames(
            "Products-item min-h-[330px] min-w-full h-auto bg-white",
            {
              "md:col-start-2": index % 3 === 0 && index !== 0,
            }
          )}
          data-test="APPLE_PRODUCT_CARD"
          onClick={() => {
            onProductClick(product);
          }}
          key={product.sku}
        >
          <AppleFeaturedCategoryProductCard
            product={product}
            onProductClick={onProductClick}
          />
        </li>
      ))}
  </ul>
);

export default AppleFeaturedCategoryCard;
